import "antd/lib/card/style";
import _Card from "antd/lib/card";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@通用组件-用于显示数据的头部组件*/
import React from 'react';
import { injectIntl } from "react-intl";
import { connect } from 'dva';
var Option = _Select.Option;
var BossHeaderChoose = /*#__PURE__*/function (_React$Component) {
  _inherits(BossHeaderChoose, _React$Component);
  function BossHeaderChoose(props) {
    var _this;
    _classCallCheck(this, BossHeaderChoose);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BossHeaderChoose).call(this, props)); //获取当前id公司信息
    // getCompanyList = () => {
    //     this.props.dispatch({
    //         type: "bi0001Info/getCompanyList",
    //         payload: {
    //             company_saas:'SaaS'
    //         }
    //     })
    // };
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_company_list", function (company_id) {
      _this.props.dispatch({
        type: "bi0001Info/get_company_list",
        payload: {
          company_id: company_id,
          company_saas: _this.state.company_saas,
          basic: true
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e, option) {
      _this.setState({
        company_id: e,
        companyInfo: e ? option.props.option : {}
      });
      _this.props.dispatch({
        type: "bi0001Info/setBossHeaderChooseValue",
        payload: {
          company_id: e
        }
      });
      if (e) {
        // this.get_company_list(e);
        _this.props.onChange(e, option.props.label, option.props.is_new, option.props.option);
      } else {
        _this.props.onChange(e, '', '', '');
      }
    });
    _this.state = {
      company_id: _this.props.company_id || '',
      company_saas: _this.props.company_saas || '',
      companyInfo: {}
    };
    return _this;
  }
  _createClass(BossHeaderChoose, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.props.dispatch({
        type: "bi0001Info/getCompanyList",
        payload: {
          company_saas: this.state.company_saas,
          basic: true,
          status: '试用,正式,停用'
        },
        callback: function callback() {
          var _this2$props$bi0001In = _this2.props.bi0001Info.companyListHeader,
            companyListHeader = _this2$props$bi0001In === void 0 ? [] : _this2$props$bi0001In;
          if (_this2.props.company_id) {
            var data = companyListHeader.filter(function (item) {
              return item.id == _this2.props.company_id;
            });
            var _ref = data[0] ? data[0] : {},
              _ref$id = _ref.id,
              id = _ref$id === void 0 ? '' : _ref$id,
              _ref$name = _ref.name,
              name = _ref$name === void 0 ? '' : _ref$name,
              is_new = _ref.is_new;
            _this2.setState({
              company_id: id,
              company_name: name,
              companyInfo: data[0]
            });
            _this2.props.dispatch({
              type: "bi0001Info/setBossHeaderChooseValue",
              payload: {
                company_id: id
              }
            }); // this.get_company_list(this.props.company_id);
            _this2.props.onChange(id, name, is_new, data[0]);
          } else {
            if (_this2.props.bi0001Info.bossHeaderChooseCompany) {
              var _data = companyListHeader.filter(function (item) {
                return item.id == _this2.props.bi0001Info.bossHeaderChooseCompany;
              });
              var _ref2 = _data[0] ? _data[0] : {},
                _ref2$id = _ref2.id,
                _id = _ref2$id === void 0 ? '' : _ref2$id,
                _ref2$name = _ref2.name,
                _name = _ref2$name === void 0 ? '' : _ref2$name,
                _is_new = _ref2.is_new;
              _this2.setState({
                company_id: _id,
                company_name: _name
              });
              _this2.get_company_list(_this2.props.bi0001Info.bossHeaderChooseCompany);
              _this2.props.onChange(_id, _name, _is_new, _data[0]);
            } else {
              var len = companyListHeader.length;
              var _ref3 = companyListHeader[len - 1] ? companyListHeader[len - 1] : {},
                _ref3$id = _ref3.id,
                _id2 = _ref3$id === void 0 ? '' : _ref3$id,
                _ref3$name = _ref3.name,
                _name2 = _ref3$name === void 0 ? '' : _ref3$name,
                _is_new2 = _ref3.is_new;
              _this2.setState({
                company_id: companyListHeader[len - 1].id,
                company_name: companyListHeader[len - 1].name,
                companyInfo: companyListHeader[len - 1]
              });
              _this2.props.dispatch({
                type: "bi0001Info/setBossHeaderChooseValue",
                payload: {
                  company_id: companyListHeader[len - 1].id
                }
              }); // this.get_company_list(companyListHeader[len-1].id);
              _this2.props.onChange(_id2, _name2, _is_new2, companyListHeader[len - 1]);
            }
          }
        }
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (this.props.company_id !== nextProps.company_id) {
        var data = this.props.bi0001Info.companyListHeader.filter(function (item) {
          return item.id == nextProps.company_id;
        });
        var _ref4 = data[0] ? data[0] : {},
          _ref4$id = _ref4.id,
          id = _ref4$id === void 0 ? '' : _ref4$id,
          _ref4$name = _ref4.name,
          name = _ref4$name === void 0 ? '' : _ref4$name;
        this.setState({
          company_id: id,
          company_name: name,
          companyInfo: data[0]
        });
        this.props.dispatch({
          type: "bi0001Info/setBossHeaderChooseValue",
          payload: {
            company_id: id
          }
        }); // this.get_company_list(this.props.company_id);
        // this.props.onChange(id,name,is_new,data[0]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement(_Card, {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(_Select, {
        showSearch: true,
        style: {
          width: 250
        },
        placeholder: "\u8BF7\u9009\u62E9\u4F01\u4E1A",
        optionFilterProp: "children",
        onChange: function onChange(e, option) {
          return _this3.onChange(e, option);
        },
        value: this.state.company_id,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        allowClear: this.props.allowClear
      }, this.props.bi0001Info.companyListHeader.map(function (item) {
        return /*#__PURE__*/React.createElement(Option, {
          option: item,
          key: item.id,
          value: item.id,
          label: item.name,
          is_new: item.is_new
        }, item.company_abbr);
      })), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: 10
        },
        className: "Dropdown_span"
      }, this.state.companyInfo && this.state.companyInfo.status ? '(' + this.state.companyInfo.status + ')' : ''));
    }
  }]);
  return BossHeaderChoose;
}(React.Component);
function mapDispatchToProps(_ref5) {
  var bi0001Info = _ref5.bi0001Info;
  return {
    bi0001Info: bi0001Info
  };
}
export default connect(mapDispatchToProps)(injectIntl(BossHeaderChoose));